import React from "react";
import { useTranslation } from "react-i18next";
import Chat from "../Chat/Chat";
import CreateRecruiter from "../../views/admin/createRecruiter";
import ListRecruiter from "../../views/admin/ListRecruiter";
import Settings from "views/Settings";
import FormCustomizer from "views/Posts/FormCustomizer";
import AdminProfile from "./adminProfile";
import CompanyProfile from "./companyProfile";
import NormalizedResume from "./normalizedResume";

// Create a custom hook to generate translated routes
const useAdminRoutes = () => {
  const { t } = useTranslation();

  return [
    {
      path: "/Chat",
      name: t("routes.chat") || "Chat",
      icon: "fas fa-comment",
      component: <Chat />,
      layout: "/manager",
    },
    {
      path: "/ListRecruiter",
      name: t("routes.recruiter_list") || "List Recruiters",
      component: <ListRecruiter />,
      layout: "/manager",
    },
    {
      path: "/AdminProfile",
      name: t("routes.user_profile") || "Admin Profile",
      icon: "fas fa-users",
      component: <AdminProfile />,
      layout: "/manager",
    },
    {
      path: "/AdminCompanyProfile",
      name: t("companyProfile.title") || "Company Profile",
      icon: "fas fa-building",
      component: <CompanyProfile />,
      layout: "/manager",
    },
    {
      path: "/settings",
      name: t("routes.settings") || "Settings",
      icon: "fas fa-cog",
      component: <Settings/>,
      layout: "/manager",
    },
    {
      path: "/candidature_spontanee",
      name: t("routes.spontaneous") || "Spontaneous application",
      icon: "fas fa-cog",
      component: <FormCustomizer />,
      layout: "/manager",
    },
    {
      path: "/cv_normalised",
      name: t("navbar.cv_normalised") || "Normalized Resume",
      icon: "fas fa-file-alt",
      component: <NormalizedResume />,
      layout: "/manager",
    }
  ];
};

// Export a function that returns the routes instead of a static array
export default useAdminRoutes;